import { render } from "./SimpleModal.vue?vue&type=template&id=2c6386f5&scoped=true"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"

import "./SimpleModal.vue?vue&type=style&index=0&id=2c6386f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6386f5"]])

export default __exports__